import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'
import CustomSnackBar from '../../../../../shared/components/CustomSnackBar'
import ScreenLoading from '../../../../../shared/components/ScreenLoading'

function NewsNotifications() {
  const { loading, error, msg } = useSelector((state: IRootState) => state.novelty)
  const { error: errorTag, msg: msgTag } = useSelector((state: IRootState) => state.tag)

  return (
    <>
      <CustomSnackBar errors={[error, errorTag]} msgs={[msg, msgTag]} />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default NewsNotifications
